/*
 * Copyright 2025 coze-dev Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
/* eslint-disable */
/* tslint:disable */
// @ts-nocheck

export type Int64 = string | number;

export interface OAuthApp {
  id: Int64;
  name: string;
  client_id: string;
  description?: string;
  status: number;
  space_id: Int64;
  public_key_id?: string;
  created_at: Int64;
  updated_at: Int64;
}

export interface CreateOAuthAppRequest {
  name: string;
  description?: string;
  space_id: Int64;
}

export interface CreateOAuthAppResponseData {
  oauth_app: OAuthApp;
  client_id: string;
  public_key_id: string;
  private_key: string;
}

export interface CreateOAuthAppResponse {
  code: number;
  msg: string;
  data: CreateOAuthAppResponseData;
}

export interface ListOAuthAppsRequest {
  space_id?: Int64;
  page?: Int64;
  size?: Int64;
}

export interface ListOAuthAppsResponseData {
  oauth_apps: OAuthApp[];
  has_more?: boolean;
}

export interface ListOAuthAppsResponse {
  code: number;
  msg: string;
  data: ListOAuthAppsResponseData;
}

export interface UpdateOAuthAppRequest {
  id: Int64;
  name?: string;
  description?: string;
}

export interface UpdateOAuthAppResponse {
  code: number;
  msg: string;
}

export interface DisableOAuthAppRequest {
  id: Int64;
}

export interface DisableOAuthAppResponse {
  code: number;
  msg: string;
}

export interface DeleteOAuthAppRequest {
  id: Int64;
}

export interface DeleteOAuthAppResponse {
  code: number;
  msg: string;
}

export default class OAuthAppService<T> {
  private request: any = () => {
    throw new Error('OAuthAppService.request is undefined');
  };
  private baseURL: string | ((path: string) => string) = '';

  constructor(options?: {
    baseURL?: string | ((path: string) => string);
    request?<R>(
      params: {
        url: string;
        method: 'GET' | 'DELETE' | 'POST' | 'PUT' | 'PATCH';
        data?: any;
        params?: any;
        headers?: any;
      },
      options?: T,
    ): Promise<R>;
  }) {
    this.request = options?.request || this.request;
    this.baseURL = options?.baseURL || '';
  }

  private genBaseURL(path: string) {
    return typeof this.baseURL === 'string'
      ? this.baseURL + path
      : this.baseURL(path);
  }

  ListOAuthApps(
    req: ListOAuthAppsRequest,
    options?: T,
  ): Promise<ListOAuthAppsResponse> {
    const url = this.genBaseURL('/api/permission_api/oauth/list_oauth_apps');
    const method = 'GET';
    const params = {
      space_id: req['space_id'],
      page: req['page'],
      size: req['size'],
    };
    return this.request({ url, method, params }, options);
  }

  CreateOAuthApp(
    req: CreateOAuthAppRequest,
    options?: T,
  ): Promise<CreateOAuthAppResponse> {
    const url = this.genBaseURL('/api/permission_api/oauth/create_oauth_app');
    const method = 'POST';
    const data = {
      name: req['name'],
      description: req['description'],
      space_id: req['space_id'],
    };
    return this.request({ url, method, data }, options);
  }

  UpdateOAuthApp(
    req: UpdateOAuthAppRequest,
    options?: T,
  ): Promise<UpdateOAuthAppResponse> {
    const url = this.genBaseURL('/api/permission_api/oauth/update_oauth_app');
    const method = 'POST';
    const data = {
      id: req['id'],
      name: req['name'],
      description: req['description'],
    };
    return this.request({ url, method, data }, options);
  }

  DisableOAuthApp(
    req: DisableOAuthAppRequest,
    options?: T,
  ): Promise<DisableOAuthAppResponse> {
    const url = this.genBaseURL('/api/permission_api/oauth/disable_oauth_app');
    const method = 'POST';
    const data = { id: req['id'] };
    return this.request({ url, method, data }, options);
  }

  DeleteOAuthApp(
    req: DeleteOAuthAppRequest,
    options?: T,
  ): Promise<DeleteOAuthAppResponse> {
    const url = this.genBaseURL('/api/permission_api/oauth/delete_oauth_app');
    const method = 'POST';
    const data = { id: req['id'] };
    return this.request({ url, method, data }, options);
  }
}
